import { Box } from '@mui/material';
import { makeStyles, withStyles } from 'tss-react/mui';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useL10n } from '@uplift/hooks';

const usePolicyDisclaimerStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    alignItems: 'flex-end',
    fontSize: '14px',
  },
  infoText: {
    color: 'rgba(0, 0, 0, 0.54)',
    alignSelf: 'center',
  },
  link: {
    color: 'rgba(0, 0, 0, 0.54)',
    textDecoration: 'underline',
    fontWeight: 400,
  },
}));

export const PolicyDisclaimers = () => {
  const { classes } = usePolicyDisclaimerStyles();
  const l10n = useL10n();

  return (
    <div className={classes.container}>
      <p className={classes.infoText}>
        <a
          className={classes.link}
          rel="noreferrer"
          href={l10n.general.termsUrl}
          target="_blank"
        >
          Terms of Service
        </a>{' '}
        and{' '}
        <a
          className={classes.link}
          rel="noreferrer"
          href={l10n.general.privacyUrl}
          target="_blank"
        >
          Privacy Policy
        </a>
      </p>
      <Box>
        <CustomTooltip
          text={(
            <>
              {l10n.onboarding.footer.tooltip}
              <br />
              <br />
              <strong>{l10n.onboarding.footer.tooltipBold}</strong>
            </>
          )}
        />
      </Box>
    </div>
  );
};


const HtmlTooltip = withStyles(Tooltip, (theme) => ({
  tooltip: {
    backgroundColor: '#ffffff',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 445,
    padding: 16,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.4px',
    borderRadius: '4px',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2)',
    filter:
      'drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)), drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12))',
    '& .MuiTooltip-arrow:before': {
      color: '#ffffff',
      boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2)',
    },
  },
}));

const useStyles = makeStyles()(() => ({
  tooltipIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: '10px',
    cursor: 'pointer',
    width: '24px',
    height: '24px',
    boxSizing: 'content-box',
  },
}));

export const CustomTooltip: React.FC<{ text?: any }> = ({ text }) => {
  const { classes } = useStyles();

  return (
    <HtmlTooltip title={text} arrow>
      <InfoOutlinedIcon className={classes.tooltipIcon} />
    </HtmlTooltip>
  );
};
